import React, { useEffect } from 'react';
import '../EvaluacionMonitoreo/evaluacionMonitoreo.css';


  const DetalleEvaluacionMonitoreo2025 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Evaluación y Monitoreo a Programas 2025</h2>
            <hr className='hr-gob'/>
          </div>

          <div>
             <table className="table table-striped table-bordered">
                <thead>
                      <tr>
                        <th scope="col" colspan="2"><div className="titulo-programa">Programa</div></th>
                        <th scope="col"><div className="titulo-columna">Matriz de Indicadores de Resultados (MIR)</div></th>
                        <th scope="col"><div className="titulo-columna"><p>Ficha Técnica de Indicadores</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Reglas de Operación</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Reglamento Interno</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Evaluación realizadas</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Seguimientos</p></div></th>
                        <th scope="col"><div className="titulo-columna">Plan de Trabajo a los ASM</div></th>
                        <th scope="col"><div className="titulo-columna"><p>Seguimiento a los ASM</p></div></th>
                      </tr>
                    </thead>
              </table>
          </div>
          <div className="contenedor-tabla">
            <table className="table table-striped table-bordered">
                    <tbody>
                      <tr>
                        <th scope="row" colspan="10"><div className="th-seccion">Alimentación para el Pueblo</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención Alimentaria a Grupos Prioritarios, Personas Mayores</div></th>
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ATN_ALIM_ADULTOS_MAYORES_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div> 
                        </td>
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ATN_ALIM_ADULTOS_MAYORES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.AsistenciaAlimentariaPersonasMayoresPersonasDiscapacidad.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                            {/*  <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_ASM_ASA_ADULTOS_MAYORES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                            {/*  <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/EED_Asisten_Alimen_Adultos_Mayores_2022.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                            {/*  <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/EED_Asisten_Alimen_Adultos_Mayores_2022.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                            {/*  <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_ASM_ASA_ADULTOS_MAYORES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                            {/*  <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_ASM_ASA_ADULTOS_MAYORES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención Alimentaria a Grupos Prioritarios, Personas con Discapacidad</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ATN_ALIM_PERSONAS_DISCAPACIDAD_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ATN_ALIM_PERSONAS_DISCAPACIDAD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.AsistenciaAlimentariaPersonasMayoresPersonasDiscapacidad.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención Alimentaria a Personas en Situación de Emergencia o Desastre</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ATN_ALIM_PERS_EMERGENCIA_DESASTRE_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ATN_ALIM_PERS_EMERGENCIA_DESASTRE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.AtnAlimEmergDesastre.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención Alimentaria en los Primeros 1000 días de Vida</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ATN_ALIM_1000_DIAS_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ATN_ALIM_1000_DIAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.1000dias.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Alimentación Escolar Modalidad Caliente</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ALIMENTACION_MOD_CALIENTE_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ALIMENTACION_MOD_CALIENTE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.ModFriaModCaliente.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Alimentación Escolar Modalidad Frío</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ALIMENTACION_MOD_FRIA_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ALIMENTACION_MOD_FRIA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.ModFriaModCaliente.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Espacios de Alimentación, Encuentro y Desarrollo</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ESPACIOS_DE_ALIMENTACION_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ESPACIOS_DE_ALIMENTACION.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.EAED.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Orientación y Educación Alimentaria</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ORIENTACION_ALIMENTARIA_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ORIENTACION_ALIMENTARIA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      
                        <tr>
                        <th scope="row" colspan="10"><div className="th-seccion">Formación para Todas y Todos</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa de la Mujer Hidalguense</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_MUJER_HIDALGUENSE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_MUJER_HIDALGUENSE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/EED_CMH_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_CMH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centros de Atención Infantil (CAI)</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/EED_CAI_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Atención Infantil Burócratas</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CAI_BUROCRATAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CAI_BUROCRATAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Desarrollo Comunitario Urbano</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CDC_URBANO_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CDC_URBANO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CDC_Urbanos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/EED_CDC_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_CDCU.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <th scope="row" colspan="10"><div className="th-seccion">La Salud es Primero</div></th>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención Médica y Hospitalaria Pediátrica en Hospital del Niño DIF</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_HOSPITAL_NIÑO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_HOSPITAL_NIÑO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.AtnMedicaHospHND.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/2025_EI_HND.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_HNDIF.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención Psicológica</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ATENCION_PSICOLOGICA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ATENCION_PSICOLOGICA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.AtnPsicologica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Apoyo y Bienestar</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_APOYO_Y_BIENESTAR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_APOYO_Y_BIENESTAR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Hidalgo (CRIH)</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Regional Huehuetla</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIR_HUEHUETLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIR_HUEHUETLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Regional Huejutla de Reyes</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIR_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIR_HUEJUTLA_DE_REYES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Regional Ixmiquilpan</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIR_IXMIQUILPAN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIR_IXMIQUILPAN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Regional Santiago Tulantepec</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIR_SANTIAGO_TULANTEPEC.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIR_SANTIAGO_TULANTEPEC.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/2025_EI_CRIR_SantiagoTulantepec.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_CRIR_ST.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Regional Tula</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIR_TULA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIR_TULA_DE_ALLENDE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Rehabilitación Integral Regional Zacualtipan</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CRIR_ZACUALTIPAN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CRIR_ZACUALTIPAN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CRIHCRIRs.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Jornadas Médicas de Subespecialidad</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_JORNADAS_MEDICAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_JORNADAS_MEDICAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.JornadasMedicas.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th scope="row" colspan="10"><div className="th-seccion">Cercanía con Grupos Prioritarios</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Atención a Personas en Condiciones de Emergencia</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_APCE_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_APCE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Promoción y Envejecimiento Saludable</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ENVEJECIMIENTO_SALUDABLE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ENVEJECIMIENTO_SALUDABLE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
      
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Programa de Salud y Bienestar Comunitario</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_SALUD_BIENESTAR_COMUNITARIO_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_SALUD_BIENESTAR_COMUNITARIO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.PSBC.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Albergue del Hospital del Niño DIF</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ALBERGUE_HND.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ALBERGUE_HND.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.AlbergueHND.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Albergue Revolución</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_ALBERGUE_REVOLUCION.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_ALBERGUE_REVOLUCION.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Ayudas Técnicas</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_AYUDAS_TECNICAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_AYUDAS_TECNICAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa Cuna</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASA_CUNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CASA_CUNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa de Día María Elena Ramirez</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASADIA_MA_ELENA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CASADIA_MA_ELENA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa de la Niña</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASA_NIÑA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CASA_NINA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa de la Adolescente y Transición</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASA_ADOLESCENTE_TRANSICION.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CASA_ADOLESCENTE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa de Día Centro de Expresión Adulto Mayor</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASADIA_CEPM_USUARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_CASADIA_CEPM_USUARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Casa del Niño</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASA_NIÑO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CASA_NINO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Centro de Expresión Juvenil</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CENTRO_EXP_JUVENIL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CEJU.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.CEJU.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Desarrollo de Habilidades en Niñas, Niños y Adolescentes</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_DESARROLLO_HABILIDADES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_HABILIDADES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.DesarrolloHabilidades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/2025_EI_DHNNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_DHNNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">DIF Contigo</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_DIF_CONTIGO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_DIF_CONTIGO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.DIFContigo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes PACHUCA</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_MIGRANTES_PACHUCA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_MIGRANTES_PACHUCA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes HUEJUTLA</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_MIGRANTES_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_MIGRANTES_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes CIUDAD SAHAGUN</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_MIGRANTES_SAHAGUN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_MIGRANTES_SAHAGUN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes TEPEJI DEL RIO</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_MIGRANTES_TEPEJI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_MIGRANTES_TEPEJI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Hacia una Vida Mejor</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_HACIA_UNA_VIDA_MEJOR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_HACIA_UNA_VIDA_MEJOR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/SEG_HUVM.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_HUVM.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">La Casita</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_CASITA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_TECNICAS_2025_CASITA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Protección de los Derechos de Niñas, Niños y Adolescentes</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_PROTECCION_DERECHOS_NNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_PROTECCION_DERECHOS_NNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa">Taller de Órtesis y Prótesis</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/MIR_2025_TALLER_ORTESIS_PROTESIS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/FICHAS_2025_TALLER_ORTESIS_PROTESIS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/R.O.TallerOrtesisProtesis.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/EED_TALLER_ORTE_PRO_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PT_TOP.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
              </table>
            </div>

            <hr />
            <br /><br />

            <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                <tbody>
                  <tr>
                      <td colspan="3"><p>PROGRAMA ANUAL DE EVALUACIÓN 2025</p></td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>Programa Anual de Evaluación 2025</td>
                    <td>
                      <div>
                          <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/PAE_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                      </div>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="3"><p>TÉRMINOS DE REFERENCIA 2025</p></td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>TDR - Evaluación Específica de Desempeño</td>
                    <td>
                      <div>
                          <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/TdR_EED_2025-DIFH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>TDR - Evaluación de Indicadores</td>
                    <td>
                      <div>
                          <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/TdR_Evaluacion_de_Indicadores_DIFH_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>TDR - Seguimientos</td>
                    <td>
                      <div>
                         <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2025/TdR_Seguimiento_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                      </div>
                    </td>
                  </tr>
                 </tbody>
              </table> 

              <hr />
              <br /><br />


        </div>
      </div>
    )
}

export default DetalleEvaluacionMonitoreo2025